import { useQuery } from "@tanstack/react-query";
import { Checkbox, Form, Input, Modal, Spin, Tooltip } from "antd";
import { fetchProductsAPI } from "api/pricerApi";
import { AddTrader } from "api/teamRunApi";
import {
  CancelButton,
  PrimaryButton,
} from "components/Common/CustomButtons/CustomButtons";
import CompanyTraders from "components/EditTradeDetails/CompanysTrader";
import { FIELDS_LABEL } from "constants/addOption";
import { BACKEND_KEYS_NAME } from "constants/editTradeDetails";
import { ADD_TRADE_MODAL_INFO } from "constants/teamRun";
import { GlobalContext } from "contexts/GlobalContext";
import { toast } from "helpers/generalHelper";
import { useContext, useState } from "react";

const initialFormData = {
  name: "",
  email: "",
  trading_company_id: "",
};

function AddTraderForm({
  isOpen,
  setIsOpen = () => {},
  setTradingCompanyId,
  TradingCompanyId,
  setTraderId,
  onTraderChange,
  productId,
}) {
  const [selectedCommodity, setSelectedCommodity] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const {
    globalState: { dark_Theme },
  } = useContext(GlobalContext);

  const { data: commodityData, isLoading: commodityLoading } = useQuery(
    ["trader/products"],
    async () => {
      const res = await fetchProductsAPI();
      return res?.data.data.map((item) => ({
        label: item.title,
        value: item.id,
      }));
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  );

  const onFinish = async () => {
    setIsLoading(true);
    if (TradingCompanyId && TradingCompanyId === formData.trading_company_id) {
      setTradingCompanyId(null);
    }
    try {
      const response = await AddTrader({...formData, products: selectedCommodity});
      if (response.data?.data?.message) {
        toast(response?.data?.message, "success");
      }
      setFormData(initialFormData);
      if (
        TradingCompanyId &&
        TradingCompanyId === formData.trading_company_id
      ) {
        setTradingCompanyId(formData.trading_company_id);
        setTimeout(() => {
          setTraderId(response?.data?.data?.id);
          onTraderChange(BACKEND_KEYS_NAME.TRADER, response?.data?.data?.name);
        }, 500);
      }
      setIsOpen(false);
    } catch (error) {
      console.log("error > ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendTypeChange = (checkedValues) => {
    setSelectedCommodity(checkedValues);
  };

  const hideModal = () => {
    setIsOpen(false);
  };

  const isAnyFieldEmpty =
    !formData.name || !formData.email || !formData.trading_company_id;

  return (
    <div className="">
      <Modal
        open={isOpen}
        width={"35%"}
        centered
        className={dark_Theme && "ant-modal-dark content_dark"}
        onCancel={hideModal}
        title={ADD_TRADE_MODAL_INFO.ADD_TRADER.label}
        bodyStyle={{ height: "250px", overflow: "auto" }}
        footer={[
          <CancelButton disabled={isLoading} key="back" onClick={hideModal}>
            {ADD_TRADE_MODAL_INFO.CANCEL.label}
          </CancelButton>,
          <Tooltip
            className="ms-2"
            title={
              (isAnyFieldEmpty || selectedCommodity?.length === 0) &&
              "Please fill all the required fields"
            }
          >
            <PrimaryButton
              onClick={onFinish}
              loading={isLoading}
              disabled={
                isAnyFieldEmpty || isLoading || selectedCommodity?.length === 0
              }
              key="submit"
            >
              {ADD_TRADE_MODAL_INFO.FINISH.label}
            </PrimaryButton>
          </Tooltip>,
        ]}
      >
        <Form
          name="basic"
          className="w-100 h-100 m-auto gap-3 d-flex flex-column justify-content-center align-items-center"
          autoComplete="off"
        >
          <div className="w-100 d-flex gap-3">
            <Input
              required
              disabled={isLoading}
              placeholder="Name"
              type="text"
              onChange={(e) => {
                setFormData({ ...formData, name: e.target.value });
              }}
              value={formData.name}
            />
            <Input
              required
              disabled={isLoading}
              // prefix={<img src="email.png" alt="email" width={20} height={20} />}
              type="email"
              placeholder="Email"
              onChange={(e) => {
                setFormData({ ...formData, email: e.target.value });
              }}
              value={formData.email}
            />
          </div>
          <CompanyTraders
            isPopup
            placeholder={"Trading Company"}
            isDisabled={isLoading}
            onChange={(e) => {
              setFormData({ ...formData, trading_company_id: e });
            }}
            value={formData.trading_company_id}
            productId={productId}
          />
          <div className="w-100 d-flex justify-content-between align-items-center">
            <label className="fw-medium fs-6">Commodities:</label>
            {commodityLoading ? (
              <Spin size="small" />
            ) : (
              <Checkbox.Group
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  width: "70%",
                  gap: "10px",
                  color: "white",
                }}
                options={commodityData}
                defaultValue={selectedCommodity}
                onChange={handleSendTypeChange}
              />
            )}
          </div>
        </Form>
      </Modal>
    </div>
  );
}

export default AddTraderForm;
